import type { TimeSlot } from '../types';

interface Props {
  offeringName: string;
  slots: TimeSlot[];
  /** Send a natural-language pick into the conversation. */
  onPick: (message: string) => void;
}

/** Format an ISO slot start into a short, human-friendly local label. */
function slotLabel(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function AvailabilityCard({ offeringName, slots, onPick }: Props) {
  return (
    <div className="w-full rounded-md border border-border bg-white p-4 shadow-card animate-pop-in">
      <div className="flex items-center gap-2 text-mid">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <path d="M16 2v4M8 2v4M3 10h18" />
        </svg>
        <span className="text-xs font-semibold uppercase tracking-wide">Pick a time</span>
      </div>

      <p className="mt-2 text-sm font-semibold text-primary">{offeringName}</p>

      <div className="mt-3 flex flex-wrap gap-2">
        {slots.map((slot) => {
          const label = slotLabel(slot.start);
          const withStaff = slot.staffName ? ` with ${slot.staffName}` : '';
          return (
            <button
              key={`${slot.start}:${slot.staffId ?? ''}`}
              type="button"
              onClick={() =>
                onPick(`Book ${offeringName} on ${label}${withStaff} (${slot.start})`)
              }
              className="flex flex-col items-start rounded-sm border border-border bg-surface px-3 py-1.5 text-xs font-medium text-primary transition-colors hover:border-[var(--brand-accent)] hover:text-[var(--brand-accent)] active:scale-[0.98]"
            >
              <span>{label}</span>
              {slot.staffName && (
                <span className="text-[10px] text-mid">{slot.staffName}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default AvailabilityCard;
